import React from 'react'
import axios from 'axios';

const URL = 'https://oapi.ehrhub.co.za';
// const URL = 'http://localhost:9000';

// dilip api --------------

export const addClinic = async (data) => {
  try {
    console.log("Success");
    return await axios.post(`${URL}/addClinic`, data);
  } catch (error) {
    console.logS("orry bhai galti se bol diya, nhi ho rha", error);
  }
}

export const getClinic = async (data) => {
  try {
    console.log("done");
    return await axios.get(`${URL}/getClinic`, data);
  } catch (error) {
    console.log("Error while calling", error);
  }
}
export const getClinicAll = async (data) => {
  try {
    console.log("done");
    return await axios.get(`${URL}/getClinicAll`, data);
  } catch (error) {
    console.log("Error while calling", error);
  }
}

// Function to get an image by its name
export const getImage = async (imageName) => {
  try {
    console.log("Fetching image");
    return await axios.get(`${URL}/images/${imageName}`, { responseType: 'blob' });
  } catch (error) {
    console.log("Failed to fetch image", error);
  }
}

export const addStream = async (data) => {
  try {
    console.log("Success");
    return await axios.post(`${URL}/addStream`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getStream = async (data) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getStream`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const addRecord = async (data) => {
  try {
    console.log("Success");
    return await axios.post(`${URL}/addRecord_Category`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getRecord = async (data) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getRecord_Category`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const addRefferedby = async (data) => {
  try {
    console.log("Success");
    return await axios.post(`${URL}/addRefferedby`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getRefferedby = async (data) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getRefferedby`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}


export const addVisitType = async (data) => {
  try {
    console.log("Success");
    return await axios.post(`${URL}/addVisit_type`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getVisitType = async (data) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getVisit_type`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}


// bhavesh api ---------
//api for inserting user data
export const addUser = async (data) => {
  try {
    return await axios.post(`${URL}/AddUser`, data);
  } catch (error) {
    console.log('Error while calling addUser API', error);
  }
};

export const getuserById = async (id) => {
  try {
    return await axios.get(`${URL}/getuserById/${id}`);
  } catch (error) {
    console.log("Error while calling getuserById API", error);
  }
}


export const updateUser = async (id, data) => {
  try {
    const response = await axios.put(`${URL}/updateUser/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating updateUser:', error);
    throw error;
  }
};

// patient
export const addPatient = async (data) => {
  try {
    return await axios.post(`${URL}/AddPatient`, data)
  } catch (error) {
    console.log("Error while calling addUser API", error)
  }
}

// API to save a webcam image
export const saveWebcamImage = async (data) => {
  try {
    return await axios.post(`${URL}/save-webcam-image`, { image: data });
  } catch (error) {
    console.error("Error saving webcam image:", error);
  }
};


export const getPatient = async (data) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getPatient`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}
export const checkPassportExists = async (data) => {
  try {
    return await axios.get(`${URL}/check-passport`, data);
  } catch (error) {
    console.error("Error while calling checkPassportExists API", error);
  }
}
export const checkIdnumbers = async (data) => {
  try {
    return await axios.get(`${URL}/check-Idnumbers`, data);
  } catch (error) {
    console.error("Error while calling check-Idnumbers API", error);
  }
}
export const checkFileNumber = async (data) => {
  try {
    return await axios.get(`${URL}/check-fileno`, data);
  } catch (error) {
    console.error("Error while calling check-fileno API", error);
  }
}

export const getPatients = async (data) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getPatients`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getPlan = async (data) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getplan`, data);
  } catch (error) {
    console.log("Error while calling getplan API", error);
  }
}

export const getmedprovider = async (data) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getmedprovider`, data);
  } catch (error) {
    console.log("Error while calling getmedprovider API", error);
  }
}

export const getPatientcount = async (data) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getPatientcount`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getOnePatient = async (id) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getOnePatient/${id}`);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getPatientByMpino = async (mpino) => {
  try {
    return await axios.get(`${URL}/getPatientByMpino/${mpino}`);
  } catch (error) {
    console.log("Error while calling getPatientByMpino API", error);
  }
}

export const deletePatient = async (id) => {
  try {
    return await axios.delete(`${URL}/deletePatient/${id}`)
  } catch (error) {
    console.log("Error while calling addUser API", error)
  }
}

// Update patient by ID
export const updatePatient = async (id, data) => {
  try {
    return await axios.put(`${URL}/updatePatient/${id}`, data);
  } catch (error) {
    console.log("Error while calling updatePatient API", error);
    throw error;
  }
}
// visit 
export const addVisit = async (data) => {
  try {
    return await axios.post(`${URL}/AddVisit`, data)
  } catch (error) {
    console.log("Error : ", error)
  }
}

export const getVisit = async (data) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getVisit`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getVisitsByClinicId = async (clinic_id) => {
  try {
    return await axios.get(`${URL}/getVisitsByClinic/${clinic_id}`);
  } catch (error) {
    console.log("Error while calling get visit by clinic id API", error);
  }
}
export const getPCAREByVisitId = async (visit_id) => {
  try {
    return await axios.get(`${URL}/getPCAREByVisitId/${visit_id}`);
  } catch (error) {
    console.log("Error while calling get PCARE by visit id API", error);
  }
}

export const getTodaysVisitsByClinicId = async (clinic_id) => {
  try {
    return await axios.get(`${URL}/visits/today/${clinic_id}`);
  } catch (error) {
    console.log("Error while calling get visit by clinic id API", error);
  }
}
export const getTodaysVisitsByClinicId2 = async (clinic_id) => {
  try {
    return await axios.get(`${URL}/visits/todays/${clinic_id}`);
  } catch (error) {
    console.log("Error while calling get visit by clinic id API", error);
  }
}

export const getVisitsByPatientId = async (patient_id) => {
  try {
    return await axios.get(`${URL}/visits/${patient_id}`);
  } catch (error) {
    console.log("Error while calling get visit by patient id API", error);
  }
}
export const getPatientsByClinicId = async (clinic_id) => {
  try {
    return await axios.get(`${URL}/patients/clinic/${clinic_id}`);
  } catch (error) {
    console.log("Error while calling get patient by clinic id API", error);
  }
}
export const getPatientbyclinicid = async (clinic_id) => {
  try {
    return await axios.get(`${URL}/patients/${clinic_id}`);
  } catch (error) {
    console.log("Error while calling get patient by clinic id API", error);
  }
}

// regJob
export const addJob = async (data) => {
  try {
    console.log("Success");
    return await axios.post(`${URL}/addJob`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getJob = async (data) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getJob`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getjobById = async (id) => {
  try {
    return await axios.get(`${URL}/getjobById/${id}`);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getJobByVisit = async (visit_id) => {
  try {
    return await axios.get(`${URL}/getJobByVisit/${visit_id}`);
  } catch (error) {
    console.log("Error while calling getJobByVisit API", error);
  }
}

export const deletejob = async (id) => {
  try {
    return await axios.delete(`${URL}/${id}`)
  } catch (error) {
    console.log("Error while calling deletejob API", error)
  }
}

export const addRegion = async (data) => {
  try {
    console.log("Success");
    return await axios.post(`${URL}/addRegion`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getRegion = async (data) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getRegion`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const addWard = async (data) => {
  try {
    console.log("Success");
    return await axios.post(`${URL}/addWard`, data);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getWard = async () => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getWard`);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getWardByRegion = async (data) => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getWardById/${data}`);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const addLab = async (data) => {
  try {
    return await axios.post(`${URL}/addLabOrder`, data)
  } catch (error) {
    console.log("Error : ", error)
  }
}


export const getLab = async () => {
  try {
    return await axios.get(`${URL}/getLabOrder`);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getOneLab = async (id) => {
  try {
    return await axios.get(`${URL}/getOneLabOrder/${id}`);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const getLabOrderByVcReference = async (vc_reference) => {
  try {
    return await axios.get(`${URL}/getLabOrderByVcReference/${encodeURIComponent(vc_reference)}`);
  } catch (error) {
    console.log("Error while calling getLabOrderByVcReference API", error);
  }
}

export const searchTariffs = async (q) => {
  try {
    return await axios.get(`${URL}/tariffs/search`, { params: { q } });
  } catch (error) {
    console.log("Error while calling searchTariffs API", error);
  }
}

export const deleteLab = async (id) => {
  try {
    return await axios.delete(`${URL}/deleteLabOrder/${id}`)
  } catch (error) {
    console.log("Error while calling addUser API", error)
  }
}

export const getUsers = async () => {
  try {
    return await axios.get(`${URL}/getUsers`);
  } catch (error) {
    console.log("data is not fetched", error);
  }
}

export const getClinicById = async (id) => {
  try {
    // console.log("getClinicById");
    return await axios.get(`${URL}/getClinicById/${id}`);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const addPCARE = async (data) => {
  try {
    return await axios.post(`${URL}/Addpatientcare`, data)
  } catch (error) {
    console.log("Error : ", error)
  }
}

export const getPCARE = async () => {
  try {
    return await axios.get(`${URL}/ViewPatientcare`);
  } catch (error) {
    console.log("data is not fetched", error);
  }
}

export const getPCAREById = async (id) => {
  try {
    return await axios.get(`${URL}/getPCAREById/${id}`);
  } catch (error) {
    console.log("Error while calling addUser API", error);
  }
}

export const addTakeFrame = async (data) => {
  try {
    return await axios.post(`${URL}/addTakeFrame`, data);
  } catch (error) {
    console.log("Error while calling addTakeFrame API", error);
  }
}

export const getTakeFrames = async () => {
  try {
    return await axios.get(`${URL}/getTakeFrames`);
  } catch (error) {
    console.log("Error while calling getTakeFrames API", error);
  }
}

export const getTakeFramesByClinic = async (clinic_id) => {
  try {
    return await axios.get(`${URL}/getTakeFramesByClinic/${clinic_id}`);
  } catch (error) {
    console.log("Error while calling getTakeFramesByClinic API", error);
  }
}

export const getTakeFramesByJob = async (job_id) => {
  try {
    return await axios.get(`${URL}/getTakeFramesByJob/${job_id}`);
  } catch (error) {
    console.log("Error while calling getTakeFramesByJob API", error);
  }
}

export const getTakeFrameById = async (id) => {
  try {
    return await axios.get(`${URL}/getTakeFrameById/${id}`);
  } catch (error) {
    console.log("Error while calling getTakeFrameById API", error);
  }
}

export const deleteTakeFrame = async (id) => {
  try {
    return await axios.delete(`${URL}/deleteTakeFrame/${id}`);
  } catch (error) {
    console.log("Error while calling deleteTakeFrame API", error);
  }
}

export const addTakeLens = async (data) => {
  try {
    return await axios.post(`${URL}/addTakeLens`, data);
  } catch (error) {
    console.log("Error while calling addTakeLens API", error);
  }
}

export const getTakeLenses = async () => {
  try {
    return await axios.get(`${URL}/getTakeLenses`);
  } catch (error) {
    console.log("Error while calling getTakeLenses API", error);
  }
}

export const getTakeLensesByClinic = async (clinic_id) => {
  try {
    return await axios.get(`${URL}/getTakeLensesByClinic/${clinic_id}`);
  } catch (error) {
    console.log("Error while calling getTakeLensesByClinic API", error);
  }
}

export const getTakeLensesByJob = async (job_id) => {
  try {
    return await axios.get(`${URL}/getTakeLensesByJob/${job_id}`);
  } catch (error) {
    console.log("Error while calling getTakeLensesByJob API", error);
  }
}

export const getTakeLensById = async (id) => {
  try {
    return await axios.get(`${URL}/getTakeLensById/${id}`);
  } catch (error) {
    console.log("Error while calling getTakeLensById API", error);
  }
}

export const deleteTakeLens = async (id) => {
  try {
    return await axios.delete(`${URL}/deleteTakeLens/${id}`);
  } catch (error) {
    console.log("Error while calling deleteTakeLens API", error);
  }
}

export const deletePCARE = async (id) => {
  try {
    return await axios.delete(`${URL}/${id}`)
  } catch (error) {
    console.log("Error while calling deletePCARE API", error)
  }
}

export const addAudittrial = async (data) => {
  try {
    return await axios.post(`${URL}/sidebarcontentuser`, data)
  } catch (error) {
    console.log("Error while calling addAudittrial API ", error)
  }
}

export const getAudittrial = async () => {
  try {
    return await axios.get(`${URL}/Audittrial`);
  } catch (error) {
    console.log("data is not fetched", error);
  }
}
export const addVision = async (data) => {
  try {
    return await axios.post(`${URL}/Vision`, data)
  } catch (error) {
    console.log("Error while calling addAudittrial API ", error)
  }
}

export const getvision = async () => {
  try {
    return await axios.get(`${URL}/Vision`);
  } catch (error) {
    console.log("data is not fetched", error);
  }
}
export const addVisionType = async (data) => {
  try {
    return await axios.post(`${URL}/Vision_type`, data)
  } catch (error) {
    console.log("Error while calling Vision_type API ", error)
  }
}

export const getVisionType = async () => {
  try {
    return await axios.get(`${URL}/Vision_type`);
  } catch (error) {
    console.log("data is not fetched", error);
  }
}

export const addInvoice = async (data) => {
  try {
    return await axios.post(`${URL}/addInvoice`, data);
  } catch (error) {
    console.log('while Invoice api fetching Error ', error);
    return error.response;
  }
};

export const countInvoices = async () => {
  try {
    return await axios.get(`${URL}/countInvoice`);
  } catch (error) {
    console.log("data is not fetched", error);
  }
}


export const getInvoice = async () => {
  try {
    return await axios.get(`${URL}/getInvoice`);
  } catch (error) {
    console.log("data is not fetched", error);
  }
}

export const getInvoiceById = async (id) => {
  try {
    return await axios.get(`${URL}/getInvoiceById/${id}`);
  } catch (error) {
    console.log("Error while calling get invoice by id API", error);
  }
}

export const labordernumber = async () => {
  try {
    return await axios.get(`${URL}/laborderno`);
  } catch (error) {
    console.log("data is not fetched", error);
  }
}

export const addFrame = async (data) => {
  try {
    console.log("Success");
    return await axios.post(`${URL}/addFrame`, data);
  } catch (error) {
    console.log("Error while calling addFrame API", error);
  }
}

export const checkFrameCodeExists = async (fcode) => {
  return await axios.post(`${URL}/check-frame-code`, { fcode });
};


export const getFrames = async () => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/Frames`);
  } catch (error) {
    console.log("Error while calling getFrames API", error);
  }
}

export const getAllFrames = async () => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getFrames`);
  } catch (error) {
    console.log("Error while calling getFrames API", error);
  }
}

export const searchFrameByFcode = async (fcode, clinicid) => {
  try {
    const response = await axios.get(`${URL}/framestock/search`, {
      params: { fcode, clinicid },
    });
    return response.data;
  } catch (error) {
    console.error("Error while calling searchFrameByFcode API:", error);
    throw error;
  }
};

export const searchLensByLcode = async (lcode, clinicid) => {
  try {
    const response = await axios.get(`${URL}/lensestock/search`, {
      params: { lcode, clinicid },
    });
    return response.data;
  } catch (error) {
    console.error("Error while calling searchLensByLcode API:", error);
    throw error;
  }
};

export const addFrameMaster = async (data) => {
  try {
    console.log("Success");
    return await axios.post(`${URL}/addFrameMaster`, data);
  } catch (error) {
    console.log("Error while calling addFrame API", error);
  }
}

export const getFrameMaster = async () => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/getFrameMaster`);
  } catch (error) {
    console.log("Error while calling getFrameMaster API", error);
  }
}

export const getFrameByFcode = async (fcode) => {
  try {
    return await axios.get(`${URL}/getFrameMaster/${fcode}`);
  } catch (error) {
    console.log("Error while calling get getFrameMaster by fcode API", error);
  }
}

export const getLensByLcode = async (lcode) => {
  try {
    return await axios.get(`${URL}/getLensByLcode/${lcode}`);
  } catch (error) {
    console.log("Error while calling get getLensByLcode by fcode API", error);
  }
}

// Lens
export const addLens = async (data) => {
  try {
    console.log("Success");
    return await axios.post(`${URL}/addLens`, data);
  } catch (error) {
    console.log("Error while calling addLens API", error);
  }
}


export const getLens = async () => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/Lens`);
  } catch (error) {
    console.log("Error while calling getLens API", error);
  }
}

// LensStock
export const addLensStock = async (data) => {
  try {
    console.log("Success");
    return await axios.post(`${URL}/addLensStock`, data);
  } catch (error) {
    console.log("Error while calling addLensStock API", error);
  }
}

export const getLensStock = async () => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/LensStock`);
  } catch (error) {
    console.log("Error while calling getLensStock API", error);
  }
}

export const checkLensCodeExists = async (lcode) => {
  return await axios.get(`${URL}/check-lens-code`, {
    params: { lcode },
  });
};

// addmedproviders
export const addmedproviders = async (data) => {
  try {
    return await axios.post(`${URL}/addmedproviders`, data)
  } catch (error) {
    console.log("Error while calling addmedproviders API", error)
  }
}

export const updateMedProvider = async (id, data) => {
  try {
    return await axios.put(`${URL}/medproviders/${id}`, data);
  } catch (error) {
    console.log("Error while calling updateMedProvider API", error);
  }
};


//deletemedprovider
export const deletemedprovider = async (id) => {
  try {
    return await axios.delete(`${URL}/medproviders/${id}`);
  } catch (error) {
    console.log("Error while calling deleteMedProvider API", error);
  }
};

// addPlan
export const addPlan = async (data) => {
  try {
    return await axios.post(`${URL}/addPlan`, data)
  } catch (error) {
    console.log("Error while calling addPlan API", error)
  }
}

// updatePlan
export const updatePlan = async (id, data) => {
  try {
    return await axios.put(`${URL}/plan/${id}`, data);
  } catch (error) {
    console.log("Error while calling updatePlan API", error);
  }
};

//deletePlan
export const deletePlan = async (id) => {
  try {
    return await axios.delete(`${URL}/plan/${id}`);
  } catch (error) {
    console.log("Error while calling deletePlan API", error);
  }
};


export const updateRegion = async (id, data) => {
  try {
    return await axios.put(`${URL}/region/${id}`, data);
  } catch (error) {
    console.log("Error while calling updateRegion API", error);
  }
};

// ✅ Delete Region by ID
export const deleteRegion = async (id) => {
  try {
    return await axios.delete(`${URL}/region/${id}`);
  } catch (error) {
    console.log("Error while calling deleteRegion API", error);
  }
};

export const getRegionById = async (id) => {
  try {
    return await axios.get(`${URL}/region/${id}`);
  } catch (error) {
    console.log("Error while calling getRegionById API", error);
  }
};



export const deleteWard = async (id) => {
  try {
    return await axios.delete(`${URL}/ward/${id}`);
  } catch (error) {
    console.log("Error while calling deleteWard API", error);
  }
};

export const deleteStream = async (id) => {
  try {
    return await axios.delete(`${URL}/stream/${id}`);
  } catch (error) {
    console.error("Error while deleting stream:", error);
  }
};


export const deleteRecord = async (id) => {
  try {
    return await axios.delete(`${URL}/record/${id}`);
  } catch (error) {
    console.error("Error while deleting record", error);
  }
};


export const deleteRefferedby = async (id) => {
  try {
    return await axios.delete(`${URL}/refferedby/${id}`);
  } catch (error) {
    console.error("Error while deleting refferedby", error);
  }
};


export const deleteVisitType = async (id) => {
  try {
    return await axios.delete(`${URL}/visitType/${id}`);
  } catch (error) {
    console.error("Error while deleting visitType", error);
  }
};


// Appointment
export const addAppointment = async (data) => {
  try {
    console.log("Success");
    return await axios.post(`${URL}/addAppointment`, data);
  } catch (error) {
    console.log("Error while calling addAppointment API", error);
  }
}

export const getAppointments = async () => {
  try {
    console.log("Success");
    return await axios.get(`${URL}/appointments`);
  } catch (error) {
    console.log("Error while calling getAppointments API", error);
  }
}

// Get appointment by ID
export const getAppointmentById = async (id) => {
  try {
    return await axios.get(`${URL}/appointments/${id}`);
  } catch (error) {
    console.log("Error while calling getAppointmentById API", error);
  }
};

export const deleteAppointment = async (id) => {
  try {
    return await axios.delete(`${URL}/appointments/${id}`);
  } catch (error) {
    console.error("Error while deleting appointments", error);
  }
};

export const getAppointmentsByClinic = async (clinic_id) => {
  try {
    return await axios.get(`${URL}/getAppointmentsByClinic/${clinic_id}`);
  } catch (error) {
    console.log("Error while calling get Appointments by clinic id API", error);
  }
}

export const deleteClinic = async (id) => {
  try {
    return await axios.delete(`${URL}/clinics/${id}`);
  } catch (error) {
    console.error("Error while deleting clinics", error);
  }
};

export const updateClinic = async (id, data) => {
  try {
    return await axios.put(`${URL}/clinic/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (error) {
    console.log("Error while calling updateClinic API", error);
    throw error;
  }
};

export const toggleClinicStatus = async (id) => {
  try {
    return await axios.patch(`${URL}/clinic/${id}/toggle-status`);
  } catch (error) {
    console.log("Error while calling toggleClinicStatus API", error);
    throw error;
  }
};

export const getVisitCountByPatientId = async (patient_id) => {
  try {
    return await axios.get(`${URL}/visit/count/patient/${patient_id}`);
  } catch (error) {
    console.log("Error while calling get invoice by id API", error);
  }
}

// Invoice New
export const getNextInvoiceNo = async () => {
  try {
    return await axios.get(`${URL}/invoiceNew/nextNo`);
  } catch (error) {
    console.log('Error fetching next invoice number', error);
  }
};

export const addInvoiceNew = async (data) => {
  try {
    return await axios.post(`${URL}/invoiceNew/add`, data);
  } catch (error) {
    console.log('Error saving invoice', error);
    return error.response;
  }
};

export const getInvoicesNew = async () => {
  try {
    return await axios.get(`${URL}/invoiceNew/list`);
  } catch (error) {
    console.log('Error fetching invoices', error);
  }
};

export const getInvoiceNewById = async (id) => {
  try {
    return await axios.get(`${URL}/invoiceNew/${id}`);
  } catch (error) {
    console.log('Error fetching invoice by id', error);
  }
};

export const getTodaysVisits = async (data) => {
  try {
    console.log("done");
    return await axios.get(`${URL}/visit/today`, data);
  } catch (error) {
    console.log("Sorry visit/today ", error);
  }
};
export const getNextMpino = (clinicId) => {
  try {
    return axios.get(`${URL}/next-mpino`, {
      params: { clinicId }
    });
  } catch (error) {
    console.log("Sorry visit/today ", error);
  }
}

// Clinic Schedule
export const getClinicSchedule = async (clinic, year, month) => {
  try {
    return await axios.get(`${URL}/getClinicSchedule`, { params: { clinic, year, month } });
  } catch (error) {
    console.log("Error fetching clinic schedule", error);
  }
};

export const saveClinicSchedule = async (data) => {
  try {
    return await axios.post(`${URL}/saveClinicSchedule`, data);
  } catch (error) {
    console.log("Error saving clinic schedule", error);
  }
};

export const getAvailableSlots = async (clinic, date) => {
  try {
    return await axios.get(`${URL}/getAvailableSlots`, { params: { clinic, date } });
  } catch (error) {
    console.log("Error fetching available slots", error);
  }
};

export const getNextFileNumber = (lastname) => {
  try {

    return axios.get(`${URL}/next-fileno`, {
      params: { lastname }
    });
  } catch (error) {
    console.log("Sorry visit/today ", error);
  }
};

// Dashboard
export const getAdminDashboard = async () => {
  try {
    return await axios.get(`${URL}/dashboard/admin`);
  } catch (error) {
    console.log('Error fetching admin dashboard', error);
  }
};

export const getClinicDashboard = async (clinicId) => {
  try {
    return await axios.get(`${URL}/dashboard/clinic/${clinicId}`);
  } catch (error) {
    console.log('Error fetching clinic dashboard', error);
  }
};
